module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copies"
  }, [_c('navbar'), _vm._v(" "), _c('h1', [_vm._v("Copies")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.copies), function(copy) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(copy.Text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Signature))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.Consulted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(copy.NumberOfUserstraces))])])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Signature")]), _vm._v(" "), _c('th', [_vm._v("Consulted")]), _vm._v(" "), _c('th', [_vm._v("# User traces")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3101c05f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/copies.vue
// module id = 245
// module chunks = 1